import { camelizeKeys } from 'humps'

import type { User } from '@/types/user'

export interface AppConfig {
  user: User | null
  environment: string
  chatTransport: 'cable' | 'sse'
}

type AppWindow = Window & { appConfig?: Record<string, unknown> }

let cached: AppConfig | null = null

const getAppConfig = (): AppConfig => {
  if (cached) return cached
  const raw = (window as unknown as AppWindow).appConfig ?? {}
  cached = camelizeKeys(raw) as unknown as AppConfig
  return cached
}

export default getAppConfig
